import "./styles/main.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { Elm } from "./Main.elm";
import registerServiceWorker from "./registerServiceWorker";
import logoPath from "../public/assets/slayt_large.png";
import slayt_square from "../public/assets/slayt_square.jpg";

TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo("en-US");

const config = {
  apiKey: "AIzaSyDnZ1rq5Oj_Wx7lW3zreXTlyPyQhkUBGUk",
  authDomain: "onetalent-prod.firebaseapp.com",
  projectId: "onetalent-prod",
};

firebase.initializeApp(config);

const formatDate = (date) => {
  if (!date) {
    return "";
  }
  return timeAgo.format(date, "twitter-minute-now");
};

let app = Elm.Main.init({
  node: document.getElementById("root"),
  flags: {
    logoPath: logoPath,
    slayt_square: slayt_square,
  },
});

app.ports.changeWindowHeight.subscribe(function () {
  window.setTimeout(() => {
    var elem = document.getElementById("messages-container");
    if (elem) {
      $(elem).scrollTop(1000000);
    }
  }, 200);
});

app.ports.fireBaseSignUp.subscribe(function (login) {
  firebase
    .auth()
    .createUserWithEmailAndPassword(login[0], login[1])
    .then(function (result) {
      window.localStorage.setItem("refresh", result.user.refreshToken);
      window.localStorage.setItem("token", result.user.uid);
      window.localStorage.setItem("jwt", result.user.ra);
      app.ports.toElmSignUp.send(result.user.ra);
    })
    .catch(function (error) {
      app.ports.toElmSignUpError.send(error.message);
    });
});

app.ports.fireBaseLogin.subscribe(function (login) {
  firebase
    .auth()
    .signInWithEmailAndPassword(login[0], login[1])
    .then(function (result) {
      window.localStorage.setItem("refresh", result.user.refreshToken);
      window.localStorage.setItem("token", result.user.uid);
      window.localStorage.setItem("jwt", result.user.ra);
      app.ports.toElmSignIn.send(result.user.ra);
    })
    .catch(function (error) {
      app.ports.toElmSignInError.send(error.message);
    });
});

app.ports.fetchNewToken.subscribe(function () {
  if (firebase.auth().currentUser) {
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function (idToken) {
        window.localStorage.setItem("jwt", idToken);
        app.ports.toElmRefreshedToken.send(idToken);
      })
      .catch(function (error) {});
  }
});

app.ports.getUserToken.subscribe(function () {
  const jwt = window.localStorage.getItem("jwt");
  if (jwt) {
    app.ports.toElmToken.send(jwt);
  } else {
    app.ports.toElmToken.send("");
  }
});

app.ports.removeUserToken.subscribe(function () {
  firebase.auth().signOut().then(window.localStorage.clear());
});

app.ports.sendPasswordResetEmail.subscribe(function (emailAddress) {
  var auth = firebase.auth();
  var emailAddress = emailAddress;

  auth
    .sendPasswordResetEmail(emailAddress)
    .then(function () {
      app.ports.passwordEmailSent.send("success");
    })
    .catch(function (error) {
      app.ports.passwordEmailSent.send("error");
    });
});

document.body.addEventListener("dragstart", (event) => {
  if (event.target && event.target.draggable) {
    // absurdly, this is needed for Firefox; see https://medium.com/elm-shorts/elm-drag-and-drop-game-630205556d2
    event.dataTransfer.setData("text/html", "blank");
  }
});

document.body.addEventListener("dragover", (event) => {
  // this is needed in order to make dragging work
  return false;
});

//TWILLIO INTEGRATION
let emptyChannel = {
  id: "",
  roleName: "",
  projectName: "",
  jobPosterName: "",
  jobPosterAvatar: "",
  projectId: "",
  roleId: "",
  talentName: "",
  talentAvatar: "",
  unreadMessages: 0,
  dateUpdated: "",
  lastMessage: "",
  talentId: "",
  roleMemberId: "",
  archived: false,
  dateUpdated: "",
  messages: [],
  jobPosterId: "",
};
let payload = {
  channels: [],
  messages: [],
  currentChannel: emptyChannel,
  cmd: "",
};

app.ports.twilio.subscribe(async function (data) {
  Twilio.Chat.Client.create(data.token)
    .then(async (client) => {
      switch (data.cmd) {
        case "getChannels":
          let allChannels = await getAllChannels(client);
          let payload = await createPayload(
            allChannels.state.items,
            {},
            "gotChannels",
            client
          );

          app.ports.dataFromTwilio.send(payload);
          break;
        case "createChannel":
          createChannel(client, data);
          break;
        case "refreshTwilioToken":
          client.updateToken(data.token);
          break;
        case "sendMessage":
          sendMessageToUser(client, data, data.payload.creatorId);
          break;
        case "archiveChannel":
          archiveChannel(client, data);
          break;
        case "markConversationAsRead":
          markMessagesAsRead(client, data.payload.channelId);
          break;
        case "archiveAllConversations":
          archiveChannels(client, data.payload.channelIds);
          break;
        case "editMessage":
          console.log("Editing Message");
          break;
        case "joinChannel":
          console.log("Joining channel");
          break;
        case "acceptChannelInvite":
          console.log("Accepting channel invite");
          break;
        case "inviteToChannel":
          console.log("inviting User to channel");
          break;
        default:
          console.log("Logging in and subscribing to channels!");
          subscribeToAllChannels(client);
          break;
      }

      //when the token is about to expire, send request to get another token.
      client.on("tokenAboutToExpire", async function () {
        let payload = await createPayload(
          [],
          emptyChannel,
          "refreshTwilioToken",
          client
        );
        app.ports.dataFromTwilio.send(payload);
      });
    })
    .catch((error) => {
      console.log(error);
    });
});

async function markMessagesAsRead(client, channelId) {
  let channel = await client.getChannelBySid(channelId);
  await channel.setAllMessagesConsumed();
  let payload = await createPayload(
    [],
    channel,
    "markedMessagesAsRead",
    client
  );
  app.ports.dataFromTwilio.send(payload);
}

async function archiveChannels(client, channelIds) {
  let archivedChannels = channelIds.forEach(async (id) => {
    let chan = await client.getChannelBySid(id);
    chan.state.attributes.archived = true;
    await chan.updateAttributes(chan.state.attributes);
  });
}
async function archiveChannel(client, data) {
  let channel = await getChannelBySid(client, data.payload.channelId);
  channel.state.attributes.archived = !channel.state.attributes.archived;
  let updateAttributes = await channel.updateAttributes(
    channel.state.attributes
  );
}

async function getAllChannels(client) {
  return await client.getUserChannelDescriptors();
}

async function deleteAllChannels(client) {
  let allChannels = await client.getUserChannelDescriptors();
  let fullChannels = allChannels.state.items.forEach(async (channel) => {
    let fullChannel = await client.getChannelBySid(channel.sid);
    await fullChannel.delete();
  });
}

async function createChannel(client, data) {
  let randomName = Math.random().toString(36).substring(7);
  let createdChannel = await client.createChannel({
    uniqueName: randomName,
    friendlyName: data.payload.friendlyName,
    isPrivate: true,
    attributes: {
      roleName: data.payload.roleName,
      projectName: data.payload.projectName,
      jobPosterName: data.payload.jobPosterName,
      jobPosterAvatar: data.payload.jobPosterAvatar,
      projectId: data.payload.projectId,
      roleId: data.payload.roleId,
      talentName: data.payload.talentName,
      talentAvatar: data.payload.talentAvatar,
      talentId: data.payload.talentIdentity,
      roleMemberId: data.payload.roleMemberId,
      archived: false,
      jobPosterId: data.payload.jobPosterId,
    },
  });
  await addUserToChannel(createdChannel, data.payload.jobPosterIdentity);
  await addUserToChannel(createdChannel, data.payload.talentIdentity);
  await sendMessageInChannel(
    createdChannel,
    data,
    data.payload.jobPosterIdentity
  );
  await createdChannel.setAllMessagesConsumed();
  createdChannel.on("messageAdded", async (message) => {
    let payload = await newMessagePayload(client, message, createdChannel);
    return app.ports.dataFromTwilio.send(payload);
  });
  let allChannels = await client.getUserChannelDescriptors();
  let payload = await createPayload(
    allChannels.state.items,
    createdChannel,
    "createdChannel",
    client
  );
  app.ports.dataFromTwilio.send(payload);
}

async function subscribeToAllChannels(client) {
  const allChannels = await client.getUserChannelDescriptors();
  allChannels.state.items.forEach(async (chan) => {
    const channel = await client.getChannelBySid(chan.sid);
    channel.on("messageAdded", async (message) => {
      let payload = await newMessagePayload(client, message, channel);
      app.ports.dataFromTwilio.send(payload);
    });
  });
}

async function newMessagePayload(client, message, channel) {
  await updateChannelStatus(message, client, channel);
  let updatedChannels = await client.getUserChannelDescriptors();
  let payload = await createPayload(
    updatedChannels.state.items,
    channel,
    "newMessage",
    client,
    { items: [message] }
  );
  return payload;
}
async function updateChannelStatus(message, client, channel) {
  if (message.state.author == client.user.state.identity) {
    return await channel.setAllMessagesConsumed();
  }
}

async function getMessages(channel) {
  let messages = await channel.getMessages();
  return messages;
}
function getChannelBySid(client, id) {
  return client.getChannelBySid(id);
}

async function sendMessageToUser(client, data, user) {
  let channel = await client.getChannelBySid(data.payload.channelId);
  let message = await sendMessageInChannel(channel, data, user);
  await channel.setAllMessagesConsumed();
  let allChannels = await client.getUserChannelDescriptors();
  let payload = await createPayload(
    allChannels.state.items,
    channel,
    "sentMessage",
    client
  );
  app.ports.dataFromTwilio.send(payload);
}
async function sendMessageInChannel(channel, data, user) {
  if (data.payload.body === "") {
    await sendFileInChannel(channel, data, user);
  } else {
    await channel.sendMessage(data.payload.body, { creatorId: user });
  }
}

async function sendFileInChannel(channel, data, user) {
  if ($("#chat-file-input")[0].files[0]) {
    let formData = new FormData();
    formData.append("file", $("#chat-file-input")[0].files[0]);
    return await channel.sendMessage(formData, { creatorId: user });
  }
}

async function addUserToChannel(channel, identity) {
  return await channel.add(identity);
}

async function mapResponseMessages(messages) {
  if (messages.length == 0) {
    return [];
  }
  const messageResponse = messages.items.map(async (message) => {
    let response;
    if (message.type === "media") {
      return await mediaResponse(message);
    } else {
      return await textResponse(message);
    }
  });
  return Promise.all(messageResponse);
}

async function mediaResponse(message) {
  let downloadUrl = await message.media.getContentUrl();
  return {
    id: message.state.sid || "",
    creatorId:
      (message.state.attributes && message.state.attributes.creatorId) || "",
    name: (message.state.attributes && message.state.attributes.name) || "",
    timeStamp: formatDate(message.state.dateUpdated) || "",
    body: message.media.filename + " (Click to view file)",
    conversationId: message.channel.sid || "",
    downloadUrl: downloadUrl,
    fileName: message.media.filename,
    size: message.media.size,
    messageType: "media",
    contentType: message.media.contentType,
  };
}

function textResponse(message) {
  return {
    id: message.state.sid || "",
    creatorId:
      (message.state.attributes && message.state.attributes.creatorId) || "",
    name: (message.state.attributes && message.state.attributes.name) || "",
    timeStamp: formatDate(message.state.dateUpdated) || "",
    body: message.state.body || "",
    conversationId: message.channel.sid || "",
    downloadUrl: "",
    fileName: "",
    size: 0,
    messageType: "text",
    contentType: "",
  };
}
async function mapChannels(channels, client) {
  if (channels.length == 0) {
    return [];
  }
  const channelResponse = channels.map(async (channel) => {
    let fullChannel = await client.getChannelBySid(channel.sid);
    let allMessages = await fullChannel.getMessages();
    let mappedMessages = await mapResponseMessages(allMessages);
    let message = allMessages.items.pop();
    let lastMessage = lastMessageResponse(message);
    return createChannelDescriptorObject(channel, lastMessage, mappedMessages);
  });
  return Promise.all(channelResponse);
}

function lastMessageResponse(message) {
  if (!message) {
    return { lastMessage: "", timestamp: "", dateUpdated: "" };
  } else {
    let lastMessage =
      message.state.type == "media" ? "Media Message" : message.state.body;
    let timestamp = formatDate(message.state.timestamp);

    return {
      lastMessage: lastMessage,
      timestamp: timestamp,
      dateUpdated: message.state.timestamp,
    };
  }
}

function createChannelDescriptorObject(channel, lastMessage, messages) {
  if (Object.keys(channel).length === 0) {
    return emptyChannel;
  } else {
    return {
      id: channel.sid || "",
      roleName: (channel.attributes && channel.attributes.roleName) || "",
      projectName: (channel.attributes && channel.attributes.projectName) || "",
      jobPosterName:
        (channel.attributes && channel.attributes.jobPosterName) || "",
      jobPosterAvatar:
        (channel.attributes && channel.attributes.jobPosterAvatar) || "",
      talentName: (channel.attributes && channel.attributes.talentName) || "",
      talentAvatar:
        (channel.attributes && channel.attributes.talentAvatar) || "",
      unreadMessages:
        (channel.descriptor && channel.descriptor.unread_messages_count) || 0,
      dateUpdated: lastMessage.timestamp || "",
      lastMessage: lastMessage.lastMessage,
      talentId: (channel.attributes && channel.attributes.talentId) || "",
      roleMemberId:
        (channel.attributes && channel.attributes.roleMemberId) || "",
      archived: (channel.attributes && channel.attributes.archived) || false,
      updatedDate: lastMessage.dateUpdated,
      messages: messages,
      projectId: channel.attributes.projectId,
      roleId: channel.attributes.roleId,
      jobPosterId: channel.attributes.jobPosterId || "",
    };
  }
}

async function createChannelObject(channel) {
  if (Object.keys(channel).length === 0) {
    return emptyChannel;
  } else {
    let messages = await channel.getMessages();
    let mappedMessages = await mapResponseMessages(messages);
    return {
      id: channel.sid || "",
      roleName: (channel.state && channel.state.attributes.roleName) || "",
      projectName:
        (channel.state && channel.state.attributes.projectName) || "",
      jobPosterName:
        (channel.state && channel.state.attributes.jobPosterName) || "",
      jobPosterAvatar:
        (channel.state && channel.state.attributes.jobPosterAvatar) || "",
      talentName: (channel.state && channel.state.attributes.talentName) || "",
      talentAvatar:
        (channel.state && channel.state.attributes.talentAvatar) || "",
      unreadMessages: 0,
      dateUpdated: formatDate(channel.state.dateUpdated) || "",
      lastMessage: "",
      talentId: (channel.state && channel.state.attributes.talentId) || "",
      roleMemberId:
        (channel.state && channel.state.attributes.roleMemberId) || "",
      archived: (channel.state && channel.state.attributes.archived) || false,
      messages: mappedMessages,
      projectId: (channel.state && channel.state.attributes.projectId) || "",
      roleId: (channel.state && channel.state.attributes.roleId) || "",
      jobPosterId:
        (channel.state && channel.state.attributes.jobPosterId) || "",
    };
  }
}

async function createPayload(channels, channel, cmd, client, messages = []) {
  let mappedChannels = await mapChannels(channels, client);
  let mappedMessages = await mapResponseMessages(messages);
  let sortedChannels = mappedChannels.sort((a, b) => {
    return b.updatedDate - a.updatedDate;
  });
  let channelObject = await createChannelObject(channel);
  let payload = {
    channels: sortedChannels,
    messages: mappedMessages,
    currentChannel: channelObject,
    cmd: cmd,
  };
  return payload;
}

const resizeableImage = function (image) {
  let $container,
    orig_src = new Image(),
    image_target = $(image).get(0),
    event_state = {},
    constrain = false,
    min_width = 60,
    min_height = 60,
    max_width = 1000,
    max_height = 1000,
    resize_canvas = document.createElement("canvas");
  const init = function () {
    orig_src.src = image_target.src;

    $(image_target)
      .wrap('<div class="resize-container"></div>')
      .before('<span class="resize-handle resize-handle-nw"></span>')
      .before('<span class="resize-handle resize-handle-ne"></span>')
      .after('<span class="resize-handle resize-handle-se"></span>')
      .after('<span class="resize-handle resize-handle-sw"></span>');

    $container = $(image_target).parent(".resize-container");

    $container.on("mousedown touchstart", ".resize-handle", startResize);
    $container.on("mousedown touchstart", "img", startMoving);
    $(".js-crop").on("click", crop);
  };

  const startResize = function (e) {
    e.preventDefault();
    e.stopPropagation();
    saveEventState(e);
    $(document).on("mousemove touchmove", resizing);
    $(document).on("mouseup touchend", endResize);
  };

  const endResize = function (e) {
    e.preventDefault();
    $(document).off("mouseup touchend", endResize);
    $(document).off("mousemove touchmove", resizing);
  };

  const saveEventState = function (e) {
    event_state.container_width = $container.width();
    event_state.container_height = $container.height();
    event_state.container_left = $container.offset().left;
    event_state.container_top = $container.offset().top;
    event_state.mouse_x =
      (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) +
      $(window).scrollLeft();
    event_state.mouse_y =
      (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) +
      $(window).scrollTop();
    // This is a fix for mobile safari
    // For some reason it does not allow a direct copy of the touches property
    if (typeof e.originalEvent.touches !== "undefined") {
      event_state.touches = [];
      $.each(e.originalEvent.touches, function (i, ob) {
        event_state.touches[i] = {};
        event_state.touches[i].clientX = 0 + ob.clientX;
        event_state.touches[i].clientY = 0 + ob.clientY;
      });
    }
    event_state.evnt = e;
  };

  const resizing = function (e) {
    let mouse = {},
      width,
      height,
      left,
      top,
      offset = $container.offset();
    mouse.x =
      (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) +
      $(window).scrollLeft();
    mouse.y =
      (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) +
      $(window).scrollTop();

    if ($(event_state.evnt.target).hasClass("resize-handle-se")) {
      width = mouse.x - event_state.container_left;
      height = mouse.y - event_state.container_top;
      left = event_state.container_left;
      top = event_state.container_top;
    } else if ($(event_state.evnt.target).hasClass("resize-handle-sw")) {
      width =
        event_state.container_width - (mouse.x - event_state.container_left);
      height = mouse.y - event_state.container_top;
      left = mouse.x;
      top = event_state.container_top;
    } else if ($(event_state.evnt.target).hasClass("resize-handle-nw")) {
      width =
        event_state.container_width - (mouse.x - event_state.container_left);
      height =
        event_state.container_height - (mouse.y - event_state.container_top);
      left = mouse.x;
      top = mouse.y;
      if (constrain || e.shiftKey) {
        top = mouse.y - ((width / orig_src.width) * orig_src.height - height);
      }
    } else if ($(event_state.evnt.target).hasClass("resize-handle-ne")) {
      width = mouse.x - event_state.container_left;
      height =
        event_state.container_height - (mouse.y - event_state.container_top);
      left = event_state.container_left;
      top = mouse.y;
      if (constrain || e.shiftKey) {
        top = mouse.y - ((width / orig_src.width) * orig_src.height - height);
      }
    }

    if (constrain || e.shiftKey) {
      height = (width / orig_src.width) * orig_src.height;
    }

    if (
      width > min_width &&
      height > min_height &&
      width < max_width &&
      height < max_height
    ) {
      resizeImage(width, height);
      // Without this Firefox will not re-calculate the the image dimensions until drag end
      $container.offset({ left: left, top: top });
    }
  };

  const resizeImage = function (width, height) {
    resize_canvas.width = width;
    resize_canvas.height = height;
    resize_canvas.getContext("2d").drawImage(orig_src, 0, 0, width, height);
    $(image_target).attr("src", resize_canvas.toDataURL("image/png"));
  };

  const startMoving = function (e) {
    e.preventDefault();
    e.stopPropagation();
    saveEventState(e);
    $(document).on("mousemove touchmove", moving);
    $(document).on("mouseup touchend", endMoving);
  };

  const endMoving = function (e) {
    e.preventDefault();
    $(document).off("mouseup touchend", endMoving);
    $(document).off("mousemove touchmove", moving);
  };

  const moving = function (e) {
    let mouse = {},
      touches;
    e.preventDefault();
    e.stopPropagation();

    touches = e.originalEvent.touches;
    mouse.x =
      (e.clientX || e.pageX || touches[0].clientX) + $(window).scrollLeft();
    mouse.y =
      (e.clientY || e.pageY || touches[0].clientY) + $(window).scrollTop();

    $container.offset({
      left: mouse.x - (event_state.mouse_x - event_state.container_left),
      top: mouse.y - (event_state.mouse_y - event_state.container_top),
    });
    let width = event_state.container_width,
      height = event_state.container_height;
    resizeImage(width, height);
    // Watch for pinch zoom gesture while moving
    if (
      event_state.touches &&
      event_state.touches.length > 1 &&
      touches.length > 1
    ) {
      let width = event_state.container_width,
        height = event_state.container_height;
      let a = event_state.touches[0].clientX - event_state.touches[1].clientX;
      a = a * a;
      let b = event_state.touches[0].clientY - event_state.touches[1].clientY;
      b = b * b;
      let dist1 = Math.sqrt(a + b);

      a = e.originalEvent.touches[0].clientX - touches[1].clientX;
      a = a * a;
      b = e.originalEvent.touches[0].clientY - touches[1].clientY;
      b = b * b;
      let dist2 = Math.sqrt(a + b);

      let ratio = dist2 / dist1;

      width = width * ratio;
      height = height * ratio;
      resizeImage(width, height);
    }
  };

  const crop = function () {
    let crop_canvas,
      left = $(".overlay").offset().left - $container.offset().left,
      top = $(".overlay").offset().top - $container.offset().top,
      width = $(".overlay").width(),
      height = $(".overlay").height();
    crop_canvas = document.createElement("canvas");
    crop_canvas.width = width;
    crop_canvas.height = height;
    crop_canvas
      .getContext("2d")
      .drawImage(image_target, left, top, width, height, 0, 0, width, height);
    if (image_target.src.includes("http")) {
      app.ports.croppedUrl.send("");
    } else {
      let url = crop_canvas.toDataURL("image/png");
      app.ports.croppedUrl.send(url);
    }
  };

  init();
};

app.ports.kickOffResizing.subscribe(function () {
  window.setTimeout(function () {
    let image = $(".resize-image");
    resizeableImage(image);
  }, 100);
});

registerServiceWorker();

/**** ZENDESK CONFIG ****/
window.zESettings = {
  webWidget: {
    color: { theme: "#202c38" },
  },
};
